/**
 * Formats an ISO date string into a user-friendly format: "May 17, 2026 22:28"
 * @param dateStr ISO date string
 * @param locale Optional locale string
 */
export const formatGameDate = (dateStr: string, locale: string = 'en-US'): string => {
  try {
    const date = new Date(dateStr);
    
    // Using Intl.DateTimeFormat for localization
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    let formatted = new Intl.DateTimeFormat(locale, options).format(date);
    
    // The user requested "May 17, 2026 22:28" (no comma before time).
    // Intl often adds a comma or "at" before the time.
    // We'll do a simple cleanup to match the requested style while keeping localized month/day order.
    formatted = formatted.replace(/, (\d{1,2}:\d{2})/, ' $1').replace(' at ', ' ');
    
    return formatted;
  } catch (e) {
    return dateStr;
  }
};
